import React from "react";
import Title from "components/Title";
import AddAge from "./AddGender";
const TableHeader = () => {
  return (
    <div
      className="gx-d-flex gx-align-items-center gx-justify-content-between gx-mb-3"
      style={{ flexWrap: "wrap" }}
    >
      <Title title="gender.title" />
      <AddAge />
    </div>
  );
};

export default TableHeader;
